import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  AvatarComponent,
  CheckboxComponent,
  ChipsComponent,
  DropdownItemComponent,
  MultiselectFeatureDirective,
  MultiSelectTriggerComponent,
  ProtectedControlDirective,
  SearchFeatureDirective,
  Select2Component,
  Select2Item,
  Select2ListItemDirective,
  Select2SelectedItemDirective,
  SelectedItemCounterDirective,
} from '@core/user-interface-legacy';

export interface MultiselectOption extends Select2Item {
  imageUrl?: string;
  membersCount?: number;
}

@Component({
  selector: 'rt-multi-select-custom-field',
  imports: [
    Select2Component,
    DropdownItemComponent,
    Select2ListItemDirective,
    MultiSelectTriggerComponent,
    ChipsComponent,
    Select2SelectedItemDirective,
    MultiselectFeatureDirective,
    SelectedItemCounterDirective,
    CheckboxComponent,
    ProtectedControlDirective,
    ReactiveFormsModule,
    TranslatePipe,
    SearchFeatureDirective,
    AvatarComponent,
  ],
  templateUrl: './multi-select-custom-field.component.html',
  styleUrl: './multi-select-custom-field.component.less',
})
export class MultiSelectCustomFieldComponent {
  public control = input.required<FormControl<number[]>>();
  public selectOptions = input.required<MultiselectOption[]>();
  public isInvalid = input<boolean>(false);
  public isReadOnly = input.required<boolean>();

  public searchControl = new FormControl('', { nonNullable: true });

  public getTooltipLabel(hiddenItems: MultiselectOption[]): string {
    return this.isReadOnly() ? hiddenItems.map(item => item.label).join(', ') : '';
  }
}
